import React from 'react';
import { MentorManagement } from '../mentor';
import { AdminPage, AdminPageHeader, AdminPageTitle, AdminSection } from '../common/AdminPrimitives';

const MentorManagementComponent: React.FC = () => {
  return (
    <AdminPage>
      <AdminPageHeader>
        <AdminPageTitle>멘토 관리</AdminPageTitle>
      </AdminPageHeader>
      <AdminSection>
        <MentorManagement />
      </AdminSection>
    </AdminPage>
  );
};

export default MentorManagementComponent;
